import React from 'react';
import { MainLayout } from '../components/MainLayout';
import { OverduePage } from '../components/overdue/OverduePage';

export function Overdue() {
  return (
    <MainLayout>
      <OverduePage />
    </MainLayout>
  );
}